/** Быстрые варианты лимита строк в выгрузках; «Все» — без лимита. */
export const EXPORT_LIMIT_PRESETS = [10_000, 50_000, 100_000, 200_000] as const

export function formatCount(value: number): string {
  return value.toLocaleString('ru-RU')
}
